import { render } from "./SaldosContables.vue?vue&type=template&id=4482b21c"
import script from "./SaldosContables.vue?vue&type=script&lang=js"
export * from "./SaldosContables.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__